import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { ProgramMembership } from '@libs/src/models/program-membership.model';
import { MatchmakingProgramPhase } from '@libs/src/models/program.model';
import { findMatchMakingPhase } from '@libs/src/program-memberships/program-membership.helper';

@Component({
  selector: 'app-program-account-status-chip',
  templateUrl: './program-account-status-chip.component.html',
})
export class ProgramAccountStatusChipComponent implements OnChanges {
  @Input() programMembership: ProgramMembership;
  matchmakingPhase: MatchmakingProgramPhase;

  ngOnChanges(changes: SimpleChanges) {
    this.matchmakingPhase = findMatchMakingPhase(
      this.programMembership.program,
    );
  }
}
